<form class="container mt-4 goals p-4" name="goalsForm">
  <div class="card">
    <div class="row g-0">
      <div class="col-md-4">
        <app-goals-chart class="img-fluid rounded-start"></app-goals-chart>
      </div>
      <div class="col-md-8">
        <div class="card-body">
          <h5 class="card-title">Goal Calories and Macros</h5>
          <p class="card-text">Please enter the quantity, in grams, of carbohydrates, fat, and protein you wish to consume each day. Your daily caloric intake will
            be calculated based on the macronutrients you input.</p>
          <div class="row">
            <div class="col">
              <div class="form-floating">
                <input id="inputGoalCarbs" type="number" class="form-control" placeholder="0" [value]="goals.carbs" (input)="onInput($event)" name="carbsGoal">
                <label for="inputGoalCarbs">Carbs (grams)</label>
              </div>
            </div>

            <div class="col">
              <div class="form-floating">
                <input id="inputGoalFat" type="number" class="form-control" placeholder="0" [value]="goals.fat" (input)="onInput($event)" name="fatGoal">
                <label for="inputGoalFat">Fat (grams)</label>
              </div>
            </div>

            <div class="col">
              <div class="form-floating">
                <input id="inputGoalProtein" type="number" class="form-control" placeholder="0" [value]="goals.protein" (input)="onInput($event)" name="proteinGoal">
                <label for="inputGoalProtein">Protein (grams)</label>
              </div>
            </div>

            <div class="col">
              <div class="form-floating">
                <input id="inputGoalAlcohol" type="number" class="form-control" placeholder="0" [value]="goals.alcohol" (input)="onInput($event)" name="alcoholGoal">
                <label for="inputGoalAlcohol">Alcohol (grams)</label>
              </div>
            </div>

            <div class="col">
              <div class="form-floating">
                <input data-testid="inputGoalCalories" id="inputGoalCalories" type="number" class="form-control" placeholder="0" [value]="goals.totalCalories" name="caloriesGoal" readonly>
                <label for="inputGoalCalories">Calories</label>
              </div>
            </div>
          </div>
          @if(this.errorMessages.length > 0){
          <div class="alert alert-danger mt-3" role="alert">
            <h4 class="alert-heading">
              @if(this.errorMessages.length == 1){
              Error:
              } @else{
              Errors:
              }
            </h4>
            <ul>
              <li *ngFor="let errorMessage of this.errorMessages; let i = index">
                {{ errorMessage }}
              </li>
            </ul>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</form>
